<template>
    <div id="right">
        <div class="right_top">
            <div class="title" v-if="layer!=='合作社'">
                <div class="title-add" @click="fundAdd()" >资金调度</div>
                <div class="title-item">惠农资金</div>
            </div>
            <div class="title title-bg" v-else>
                <div class="title-item">惠农资金</div>
            </div>
            <div class="con" @click="fundClick()">
                <div class="fund-details">
                    <div class="fund-unit">
                        <div class="fund-unit-text">单位：万元</div>
                    </div>
                    <div style="width: 100%;height: 62%">
                        <zny-charts :chartData="chartData"/>
                    </div>
<!--                    <div id="cylinder" class="cylinder"></div>-->
                    <div class="data-list">
                        <div class="data-list-item" v-for="(item,index) in fundData" :key="index">
                            <div class="data-num">{{item.num}}</div>
                            <div class="data-line"></div>
                            <div class="data-name">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right_cen" @click="projectClick()">
            <div class="title" v-if="layer!=='合作社'">
                <div class="title-add" @click.stop="projectAdd()">添加项目</div>
                <div class="title-item">项目管理</div>
            </div>
            <div class="title title-bg" v-else>
                <div class="title-item">项目管理</div>
            </div>
            <div class="con" v-loading="projectLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="nodata-details" v-if="projectNoData">
                    <img src="../../assets/home/no-data.png" alt="" class="nodata">
                    <div class="nodata-text">暂无数据</div>
                </div>
                <div class="project-detail no-scroll" id="project_box" v-else>
                    <div id="project_scroll1" class="project-detail-item">
                        <div class="project-lists" v-for="(item,index) in projectList" :key="index" @click.stop="toProjectDetails(item)">
                            <div class="list-left">
                                <div class="left-name">{{item.swProjectName}}</div>
                                <div class="left-price">{{item.money}}万元</div>
                                <div class="left-time">时间：{{item.startTime}}</div>
                            </div>
                            <div class="list-right">
                                <el-progress :stroke-width="5" type="circle" :percentage="item.progress" :width="60" :height="60" :color="'#1b61dd'"></el-progress>
                            </div>
                        </div>
                    </div>
                    <div id="project_scroll2" class="project-detail-item" v-if="showProjectScroll2">
                        <div class="project-lists" v-for="(item,index) in projectList" :key="index" @click.stop="toProjectDetails(item)">
                            <div class="list-left">
                                <div class="left-name">{{item.swProjectName}}</div>
                                <div class="left-price">{{item.money}}万元</div>
                                <div class="left-time">时间：{{item.startTime}}</div>
                            </div>
                            <div class="list-right">
                                <el-progress :stroke-width="5" type="circle" :percentage="item.progress" :width="60" :height="60" :color="'#1b61dd'"></el-progress>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right_bot" @click="infoClick()">
            <div class="title">
                <div class="title-add" @click.stop="infoAdd()">发布</div>
                <div class="title-item">信息直报</div>
            </div>
            <div class="con"  v-loading="infoLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="nodata-details" v-if="infoNoData">
                    <img src="../../assets/home/no-data.png" alt="" class="nodata">
                    <div class="nodata-text">暂无数据</div>
                </div>
                <div class="details" v-else>
                    <div class="info-detail no-scroll" id="info_box">
                        <div id="info_scroll1" class="information-detail">
                            <div class="information-detail-list" v-for="(item,index) in informationList" :key="index" @click.stop="toInfoDetail(item.id)">
                                <div class="list-item">
                                    <div class="info-left" v-if="item.typeId==1||item.typeId==3||item.typeId==4||item.typeId==5||item.typeId==6||item.typeId==7">
                                        <div class="info-image1">
                                            <div class="info-image2">
                                                <div class="info-image3">
                                                    <img :src=item.litpic alt="" class="img-photo" :id="'info1_Image'+index" v-if="item.isShowImage">
                                                    <img src="../../assets/information/info-default.png" alt="" class="img-photo" v-if="!item.isShowImage&&(item.typeId==1||item.typeId==4||item.typeId==5||item.typeId==6||item.typeId==7)">
                                                    <img src="../../assets/information/info-default.png" alt="" class="img-photo" v-if="!item.isShowImage&&item.typeId==3">
                                                    <img src="../../assets/information/play.png" alt="" v-if="item.isShowImage&&item.typeId==3" class="img-play">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="info-right">
                                        <div class="info-right-name" v-show="item.typeId==5||item.typeId==6||item.typeId==7">{{item.title}}</div>
                                        <div class="info-right-name" v-show="item.typeId==4">{{item.checkType}}</div>
                                        <div class="info-right-name list-con-typeId">{{item.typeId | typeIdFormat}}</div>
                                        <div class="info-right-time">{{item.addTime}}</div>
                                    </div>
                                </div>
                                <div class="list-line">
                                    <!--                                <img src="../../assets/home/info-line.png" alt="">-->
                                </div>
                            </div>
                        </div>
                        <div id="info_scroll2" class="information-detail" v-if="showInfoScroll2">
                            <div class="information-detail-list" v-for="(item,index) in informationList" :key="index" @click.stop="toInfoDetail(item.id)">
                                <div class="list-item">
                                    <div class="info-left" v-if="item.typeId==1||item.typeId==3||item.typeId==4||item.typeId==5||item.typeId==6||item.typeId==7">
                                        <div class="info-image1">
                                            <div class="info-image2">
                                                <div class="info-image3">
                                                    <img :src=item.litpic alt="" class="img-photo" :id="'info1_Image'+index" v-if="item.isShowImage">
                                                    <img src="../../assets/information/info-default.png" alt="" class="img-photo" v-if="!item.isShowImage&&(item.typeId==1||item.typeId==4||item.typeId==5||item.typeId==6||item.typeId==7)">
                                                    <img src="../../assets/information/info-default.png" alt="" class="img-photo" v-if="!item.isShowImage&&item.typeId==3">
                                                    <img src="../../assets/information/play.png" alt="" v-if="item.isShowImage&&item.typeId==3" class="img-play">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="info-right">
                                        <div class="info-right-name" v-show="item.typeId==5||item.typeId==6||item.typeId==7">{{item.title}}</div>
                                        <div class="info-right-name" v-show="item.typeId==4">{{item.checkType}}</div>
                                        <div class="info-right-name list-con-typeId">{{item.typeId | typeIdFormat}}</div>
                                        <div class="info-right-time">{{item.addTime}}</div>
                                    </div>
                                </div>
                                <div class="list-line">
                                    <!--                                <img src="../../assets/home/info-line.png" alt="">-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {Chart} from '../../js/echarts';
    import eventBus from '@/eventBus.js';
    import NewManagementService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.NewManagementService'
    import FarmersMoneyAreaService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.FarmersMoneyAreaService'
    import FarmersMoneyNotAreaService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.FarmersMoneyNotAreaService'
    import SwProjectService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.SwProjectService'
    import {debounce} from "../../js/debounce";
    export default {
        components:{

        },
        data(){
            return {
                layer:localStorage.getItem('layer'),
                projectList:[],
                informationList:[],
                fundData:[
                    {name:'惠农资金',num:0},
                    {name:'作业补贴',num:0},
                    {name:'购机补贴',num:0},
                    {name:'其他资金',num:0},
                ],
                funds:[],
                projectTimer:false,
                infoTimer:false,
                showProjectScroll2:false,
                showInfoScroll2:false,
                projectScroll:null,
                infoScroll:null,
                screenWidth: document.body.clientWidth,
                screenHeight: document.body.clientHeight,
                infoPageSize:1000,
                infoCurrentPage:1,
                projectPageSize:10,
                projectCurrentPage:1,
                projectLoading:false,
                infoLoading:false,
                projectNoData:false,
                infoNoData:false,
                chartData:{//echarts图表数据
                    show:false,
                    option:{}
                },
            }
        },
        filters: {
            typeIdFormat(msg) {
                if(msg==4){
                    return "安全检查"
                }else if(msg==5){
                    return '政策解读'
                }else if(msg==6){
                    return '党建活动'
                }else if(msg==7){
                    return '农技农艺'
                }
            },
        },
        //监听屏幕的变化
        watch: {
            '$store.state.screenWidth':function(val){
                var that = this
                if (!that.timer) {
                    that.screenWidth = val
                    that.timer = true
                    setTimeout(function () {
                        that.$nextTick(function () {
                            Chart.Cylinder(that,that.funds)
                            that.timer = false
                        })

                    }, 400)
                }
            },
            '$store.state.screenHeight':function(val){
                var that = this
                if (!that.timer) {
                    that.screenHeight = val
                    that.timer = true
                    setTimeout(function () {
                        that.$nextTick(function () {
                            Chart.Cylinder(that,that.funds)
                            that.timer = false
                        })
                    }, 400)
                }
            },
            informationList: function() {
                var that = this
                that.$nextTick(function(){
                    /*现在数据已经渲染完毕*/
                    for(var i=0;i<that.informationList.length;i++){
                        //判断图片是否加载成功
                        (function (i) {
                            if(that.informationList[i].typeId==1||that.informationList[i].typeId==3||that.informationList[i].typeId==4||that.informationList[i].typeId==5||that.informationList[i].typeId==6||that.informationList[i].typeId==7){
                                document.getElementById("info1_Image"+i).onerror = function () {
                                    that.informationList[i].isShowImage=false
                                }
                            }
                        }(i))
                    }
                })
            }
        },
        mounted(){
            var that = this
            that.onload()
            that.getProjectList()
            that.getInfoList()
            that.getFundData()
        },
        methods:{
            onload(){
                var that = this
                //定时刷新
                eventBus.$on('refresh',function () {
                    that.showProjectScroll2=false
                    clearInterval(that.projectScroll)
                    that.projectScroll=null
                    that.getProjectList()
                    that.showInfoScroll2=false
                    clearInterval(that.infoScroll)
                    that.infoScroll=null
                    that.getInfoList()
                    that.getFundData()
                })
                //年份筛选
                eventBus.$on('yearChange',function () {
                    that.getProjectList()
                    that.getFundData()
                })
                //项目添加成功
                eventBus.$on('addProjectSuccess',function () {
                    var ul2 = document.getElementById("project_scroll2");
                    // ul2.innerHTML = ''
                    that.showProjectScroll2=false
                    clearInterval(that.projectScroll)
                    that.projectScroll=''
                    that.getProjectList()
                })
                //惠农资金添加或编辑成功
                eventBus.$on('addFundSuccess',function () {
                    that.getFundData()
                })
                //信息直报添加或编辑成功
                eventBus.$on('addSuccess',function () {
                    var ul2 = document.getElementById("info_scroll2");
                    // ul2.innerHTML = ''
                    that.showInfoScroll2=false
                    clearInterval(that.infoScroll)
                    that.infoScroll=null
                    that.getInfoList()
                })
                //信息直报删除成功
                eventBus.$on('deleteSuccess',function () {
                    var ul2 = document.getElementById("info_scroll2");
                    // ul2.innerHTML = ''
                    that.showInfoScroll2=false
                    clearInterval(that.infoScroll)
                    that.infoScroll=null
                    that.getInfoList()
                })
            },
            Scroll1(t){
                var that=this
                var ul1 = document.getElementById("project_scroll1");
                var ul2 = document.getElementById("project_scroll2");
                var ulbox = document.getElementById("project_box");
                var listHeight=$("#project_scroll1").outerHeight();
                var boxHeight=$("#project_box").outerHeight();
                if(listHeight>boxHeight){
                    // ul2.innerHTML = ul1.innerHTML;
                    that.showProjectScroll2=true
                    ulbox.scrollTop = 0; // 开始无滚动时设为0
                    if(that.projectScroll!=null){
                        clearInterval(that.projectScroll)
                        that.projectScroll=null
                    }
                    that.projectScroll = setInterval(that.rollStart1, t); // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
                    // 鼠标移入div时暂停滚动
                    ulbox.onmouseover = function () {
                        clearInterval(that.projectScroll);
                        that.projectScroll=null
                    }
                    // 鼠标移出div后继续滚动
                    ulbox.onmouseout = function () {
                        // that.rollStart()
                        if(that.projectScroll!=null){
                            clearInterval(that.projectScroll)
                            that.projectScroll=null
                        }
                        that.projectScroll = setInterval(that.rollStart1, t);
                    }
                }
            },
            rollStart1(){
                var ul1 = document.getElementById("project_scroll1");
                var ul2 = document.getElementById("project_scroll2");
                var ulbox = document.getElementById("project_box");
                // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
                if (ulbox.scrollTop >= ul1.scrollHeight) {
                    ulbox.scrollTop = 0;
                } else {
                    ulbox.scrollTop+=1.25;
                }
            },
            Scroll2(t){
                var that=this
                var ul1 = document.getElementById("info_scroll1");
                var ul2 = document.getElementById("info_scroll2");
                var ulbox = document.getElementById("info_box");
                var listHeight=$("#info_scroll1").outerHeight();
                // console.log(listHeight)
                var boxHeight=$("#info_box").outerHeight();
                if(listHeight>boxHeight){
                    // ul2.innerHTML = ul1.innerHTML;
                    that.showInfoScroll2=true
                    ulbox.scrollTop = 0; // 开始无滚动时设为0
                    if(that.infoScroll!=null){
                        clearInterval(that.infoScroll)
                        that.infoScroll=null
                    }
                    that.infoScroll = setInterval(that.rollStart2, t); // 设置定时器，参数t用在这为间隔时间（单位毫秒），参数t越小，滚动速度越快
                    // 鼠标移入div时暂停滚动
                    ulbox.onmouseover = function () {
                        clearInterval(that.infoScroll);
                        that.infoScroll=null
                    }
                    // 鼠标移出div后继续滚动
                    ulbox.onmouseout = function () {
                        // that.rollStart()
                        if(that.infoScroll!=null){
                            clearInterval(that.infoScroll)
                            that.infoScroll=null
                        }
                        that.infoScroll = setInterval(that.rollStart2, t);
                    }
                }
            },
            rollStart2(){
                var ul1 = document.getElementById("info_scroll1");
                var ul2 = document.getElementById("info_scroll2");
                var ulbox = document.getElementById("info_box");
                // 正常滚动不断给scrollTop的值+1,当滚动高度大于列表内容高度时恢复为0
                if (ulbox.scrollTop >= ul1.scrollHeight) {
                    ulbox.scrollTop = 0;
                } else {
                    ulbox.scrollTop+=1.25;
                }
            },
            //点击惠农资金
            fundClick(){
                var that = this
                if(that.layer!=='合作社'){
                    that.$store.state.fundElse='fundElse'
                    that.$store.state.fundBuy='fundBuy'
                    that.$store.state.fundWork='fundWork'
                    that.$store.state.list=''
                    that.$store.state.details=''
                    that.$store.state.vehicleDataDialog=false
                    that.$store.state.add=""
                    that.$store.state.detailList=''
                    that.$store.state.systemList=''
                }
            },
            //点击项目管理
            projectClick(){
                var that = this
                if(that.projectNoData){

                }else{
                    that.$store.state.fundElse=''
                    that.$store.state.fundBuy=''
                    that.$store.state.fundWork=''
                    that.$store.state.list='projectList'
                    that.$store.state.vehicleDataDialog=false
                    that.$store.state.add=""
                    that.$store.state.detailList=''
                    that.$store.state.systemList=''
                    //如果详情是项目不需要关闭
                    if(that.$store.state.details=='projectDetails'){

                    }else{
                        that.$store.state.details=''
                    }
                }
            },
            //进入项目详情
            toProjectDetails:debounce(function (item) {
                var that = this
                that.$store.state.fundElse=''
                that.$store.state.fundBuy=''
                that.$store.state.fundWork=''
                that.$store.state.vehicleDataDialog=false
                that.$store.state.detailList=''
                that.$store.state.systemList=''
                that.$store.state.add=""
                that.$store.state.list='projectList'
                that.$store.state.details="projectDetails"
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('toProjectDetails',item.swProjectId,item.swUnitPrimaryId,item.update,item.assign)
                    },500)
                })
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('fromHomeProject',item.swProjectId)
                    },500)
                })
            }),
            //点击信息直报
            infoClick(){
                var that = this
                if(that.infoNoData){

                }else{
                    that.$store.state.fundElse=''
                    that.$store.state.fundBuy=''
                    that.$store.state.fundWork=''
                    that.$store.state.list='infoList'
                    that.$store.state.details=''
                    that.$store.state.vehicleDataDialog=false
                    that.$store.state.detailList=''
                    that.$store.state.systemList=''
                    //如果详情是信息直报详情不需要关闭
                    if(that.$store.state.add=='infoDetails'){
                    }else{
                        that.$store.state.add=''
                    }
                }
            },
            //信息直报详情
            toInfoDetail(id){
                var that = this
                that.$store.state.add="infoDetails"
                that.$store.state.fundElse=''
                that.$store.state.fundBuy=''
                that.$store.state.fundWork=''
                that.$store.state.details=''
                that.$store.state.vehicleDataDialog=false
                that.$store.state.detailList=''
                that.$store.state.list='infoList'
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('infoDetail',id)
                    },500)
                })
                that.$store.state.systemList=''
            },
            //添加资金调度
            fundAdd(){
                var that = this
                that.$store.state.add="fundAdd"
                that.$store.state.fundElse=''
                that.$store.state.fundBuy=''
                that.$store.state.fundWork=''
                that.$store.state.details=""
                that.$store.state.vehicleDataDialog=false
                that.$store.state.detailList=''
                that.$store.state.systemList=''
                that.$store.state.list=''
            },
            //添加项目
            projectAdd(){
                var that = this
                that.$store.state.add="projectAdd"
                that.$store.state.fundElse=''
                that.$store.state.fundBuy=''
                that.$store.state.fundWork=''
                that.$store.state.details=''
                that.$store.state.vehicleDataDialog=false
                //如果当前不是项目列表就将其他底部列表清除
                if(that.$store.state.list!="projectList"){
                    that.$store.state.list=""
                }
                that.$store.state.detailList=''
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('projectAdd')
                    },500)
                })
                that.$store.state.systemList=''
            },
            //信息直报发布
            infoAdd(){
                var that = this
                that.$store.state.add="infoAdd"
                that.$store.state.fundElse=''
                that.$store.state.fundBuy=''
                that.$store.state.fundWork=''
                that.$store.state.details=''
                that.$store.state.vehicleDataDialog=false
                //如果当前不是信息直报列表就将其他底部列表清除
                if(that.$store.state.list!="infoList"){
                    that.$store.state.list=""
                }
                that.$store.state.detailList=''
                that.$store.state.systemList=''
                that.$nextTick(function () {
                    setTimeout(function () {
                        eventBus.$emit('infoAdd')
                    },500)
                })
            },
            //获取惠农资金
            getFundData(){
                var that = this
                if(that.layer=='县'){
                    FarmersMoneyAreaService.findFarmersMoneyStatistics(that.$store.state.time)
                        .then(res=>{
                            that.funds=res
                            that.fundData[0].num=res.total
                            that.fundData[1].num=res.work
                            that.fundData[2].num=res.vehicle
                            that.fundData[3].num=res.other
                            that.$nextTick(function () {
                                setTimeout(function () {
                                    Chart.Cylinder(that,res)
                                },500)
                            })
                        })
                        .catch(error=>{
                            console.log(error)
                        })
                }else{
                    FarmersMoneyNotAreaService.farmersMoneyOverview(that.$store.state.time)
                        .then(res=>{
                            that.funds=res
                            that.fundData[0].num=res.total
                            that.fundData[1].num=res.work
                            that.fundData[2].num=res.vehicle
                            that.fundData[3].num=res.other
                            that.$nextTick(function () {
                                setTimeout(function () {
                                    Chart.Cylinder(that,res)
                                },500)
                            })
                        })
                        .catch(error=>{
                            console.log(error)
                        })
                }

            },
            //获取项目列表
            getProjectList(){
                var that = this
                that.projectLoading=true
                SwProjectService.listProjectOverview(that.$store.state.time,that.projectCurrentPage,that.projectPageSize)
                .then(res=>{
                    that.projectLoading=false
                    if(res.voList.length>0){
                        that.projectNoData=false
                    }else{
                        that.projectNoData=true
                    }
                    for(var i=0;i<res.voList.length;i++){
                        if(res.voList[i].progress>=100){
                            res.voList[i].progress=100
                        }else{
                            res.voList[i].progress=Number(res.voList[i].progress.toFixed(2))
                        }
                    }
                    that.projectList=res.voList
                    $('.project-detail').removeClass('no-scroll');
                    that.$nextTick(function () {
                        that.Scroll1(50)

                    })
                })
                .catch(err=>{
                    that.projectLoading=false
                })
            },
            //获取信息直报列表
            getInfoList(){
                var that = this
                that.infoLoading=true
                NewManagementService.NewsInformationListForPage(that.infoCurrentPage,that.infoPageSize,'')
                .then(res=>{
                    that.infoLoading=false
                    if(res.list.length>0){
                        that.infoNoData=false
                    }else{
                        that.infoNoData=true
                    }
                    for(var i=0;i<res.list.length;i++){
                        res.list[i].isShowImage=true
                    }
                    that.informationList=res.list
                    $('.info-detail').removeClass('no-scroll');
                    that.$nextTick(function () {
                        that.Scroll2(50)
                    })
                })
                .catch(err=>{
                    that.infoLoading=false
                })
            },
        },
        beforeDestroy() {
            var that = this
            eventBus.$off('yearChange')
            eventBus.$off('addSuccess')
            eventBus.$off('deleteSuccess')
            eventBus.$off('addFundSuccess')
            eventBus.$off('addProjectSuccess')
            eventBus.$off('refresh')
            //清除定时器
            clearInterval(that.projectScroll);
            that.projectScroll=null
            clearInterval(that.infoScroll);
            that.infoScroll=null
        }
    }
</script>
<style lang="less">
    @import '../../viewsStyle/assembly/right.less';
</style>